import { Events } from '|>/shared/events'
import { div, span } from '|>/shared/h'
import { register } from '|>/shared/vjs'
import { BaseComponent } from '../base'

import './chrome-casting-message.css'

@register
export class ChromeCastingMessage extends BaseComponent {
  declare titleEl: HTMLDivElement

  constructor(player, options) {
    super(player, options)

    this.hide()

    this.player_.on(
      [Events.Chromecast.Connected, Events.Chromecast.Source],
      () => {
        this.player_.addClass('vjs-casting')
        this.show()

        this.updateTitle(this.player_.chromecastSessionManager?.getDeviceName())
      }
    )

    this.player_.on(Events.Chromecast.Disconnected, () => {
      this.player_.removeClass('vjs-casting')
      this.hide()
    })
  }

  createTitle(deviceName: string) {
    return `${this.localize('casting_status', [`"${deviceName}"`])} ${this.localize('casting_activated')}.`
  }

  updateTitle(deviceName: string) {
    if (this.titleEl) this.titleEl.innerText = this.createTitle(deviceName)
  }

  override createEl() {
    const title = this.createTitle('')
    const descriptionText = `${this.localize('please_tap_button')} `
    const stopCastingMessage = ` ${this.localize('stop_casting_message')}`

    this.titleEl = div('.vjs-x-casting-message-title', null, title)

    const firstLineEl = span(
      '.vjs-x-casting-message-description-first-line',
      null,
      [descriptionText]
    )

    const descriptionEl = span('.vjs-x-casting-message-description', null, [
      firstLineEl,
      stopCastingMessage,
    ])

    return div('.vjs-x-casting-message', null, [this.titleEl, descriptionEl])
  }
}

ChromeCastingMessage.options = {
  className: 'vjs-x-casting-message',
}
